
import { TransferAssetTypeInfoBase } from './transfer-asset.typeinfo.base';


export class TransferAssetTypeInfo extends TransferAssetTypeInfoBase {
}

export const TRANSFER_ASSET_TYPE: TransferAssetTypeInfo = new TransferAssetTypeInfo();



